import config from '../config';

// Read-only client for the Virgy public jobs API.
// Endpoints (published-only, no auth):
//   GET /api/jobs/                      -> list, organization embedded
//   GET /api/jobs/?organization=<slug>  -> list scoped to one brand
//   GET /api/jobs/<job-slug>/           -> full detail + embedded org + contact_person

const base = config.apiBase; // '' in dev (proxied), full origin in prod

async function getJSON(path) {
  const res = await fetch(`${base}${path}`, {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    const err = new Error(`API ${res.status} for ${path}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// DRF may return a bare array or a paginated { results: [...] } envelope.
function asList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export async function listJobs({ organization } = {}) {
  const qs = organization ? `?organization=${encodeURIComponent(organization)}` : '';
  return asList(await getJSON(`/api/jobs/${qs}`));
}

export async function getJob(slug) {
  return getJSON(`/api/jobs/${encodeURIComponent(slug)}/`);
}
